(function () {
  'use strict';
  if (window.UpshiftMeta) return;
  var pixelId = '4592961211030974';
  var sent = new Set();
  var initialized = false;

  function allowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(privacy && privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true);
    } catch (_) { return false; }
  }

  function cookie(name) {
    var match = document.cookie.split('; ').find(function (part) { return part.indexOf(name + '=') === 0; });
    if (!match) return undefined;
    try {
      var value = decodeURIComponent(match.slice(name.length + 1));
      return value.length <= 450 && /^fb\.\d+\.\d+\.[A-Za-z0-9_-]+$/.test(value) ? value : undefined;
    } catch (_) { return undefined; }
  }

  function initPixel() {
    if (!allowed()) return false;
    if (!initialized) {
      if (!window.fbq) {
        var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
        if (!window._fbq) window._fbq = n;
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      // Shopify's partner pixel runs in its own sandbox. This instance sends
      // ONLY our custom checkout event, never a second PageView or Purchase.
      window.fbq('set', 'autoConfig', false, pixelId);
      window.fbq('init', pixelId);
      initialized = true;
    }
    return true;
  }

  var privacyReady = new Promise(function (resolve) {
    if (window.Shopify && window.Shopify.customerPrivacy) { resolve(); return; }
    if (!window.Shopify || !window.Shopify.loadFeatures) { resolve(); return; }
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { resolve(); }); }
    catch (_) { resolve(); }
    // A consent API failure must not block checkout.
    setTimeout(resolve, 500);
  });

  privacyReady.then(function () { try { initPixel(); } catch (_) {} });
  document.addEventListener('visitorConsentCollected', function () {
    try {
      if (allowed()) {
        if (initialized) window.fbq('consent', 'grant');
        initPixel();
      } else if (initialized) { window.fbq('consent', 'revoke'); }
    } catch (_) {}
  });

  window.UpshiftMeta = {
    checkoutContext: async function () {
      try {
        await privacyReady;
        if (!allowed()) return undefined;
        // Cookie access/SDK errors must never prevent checkout or capture.
        try { initPixel(); } catch (_) {}
        return {
          consent: true,
          sourceUrl: window.location.origin + window.location.pathname,
          fbp: cookie('_fbp'),
          fbc: cookie('_fbc')
        };
      } catch (_) { return undefined; }
    },
    checkoutOpened: function (checkout, sku) {
      try {
        if (!checkout || !/^cs_(live|test)_[A-Za-z0-9]+$/.test(checkout.sessionId) || sent.has(checkout.sessionId) || !initPixel()) return;
        // Never count sandbox checkout activity in the live pixel.
        if (checkout.sessionId.indexOf('cs_live_') !== 0) return;
        var data = { content_name: 'UPSHIFT ' + sku, num_items: 1 };
        if (Number.isSafeInteger(checkout.amountTotalCents) && checkout.amountTotalCents >= 0 && checkout.currency === 'usd') {
          data.value = checkout.amountTotalCents / 100;
          data.currency = 'USD';
        }
        window.fbq('trackSingle', pixelId, 'InitiateCheckout', data, { eventID: 'upshift_checkout_' + checkout.sessionId });
        sent.add(checkout.sessionId);
      } catch (_) {}
    }
  };
})();
